import { ENV_CONFIG } from './env';
import { systemConfig } from './system.config';

export const APP_CONFIG = {
  app: {
    name: 'CLIV',
    version: ENV_CONFIG.APP_VERSION,
    description: 'CLIV — booking requests, tracking, and partner information',
  },
  api: {
    baseUrl: systemConfig.apiUrl,
    timeout: 2 * 60 * 1000,
  },
  logging: {
    enabled: ENV_CONFIG.IS_DEV,
    level: ENV_CONFIG.IS_DEV ? 'debug' : 'error',
  },
} as const;
